import React, { useCallback, useState } from 'react'
import { isEmptyString } from '../../../../utils/string-utils'
import { IconButton, Tooltip } from '@mui/material'
import AutoModeIcon from '@mui/icons-material/AutoMode'
import LiveOrdersModal from './live-orders-modal'

export interface LiveOrdersModalTriggerProps {
  strategyId: string
  strategyName: string
  isApiConnected: boolean
  liveOrdersUrl: string | null
  controlCloseOrderUrl: string | null
}

const LiveOrdersModalTrigger: React.FC<LiveOrdersModalTriggerProps> = (props) => {
  const { strategyId, strategyName, isApiConnected, liveOrdersUrl, controlCloseOrderUrl } = props
  const isDisabled = !isApiConnected || isEmptyString(liveOrdersUrl)

  const [isModalOpen, setIsModalOpen] = useState<boolean>(false)

  const openLiveOrdersModal = useCallback(() => {
    setIsModalOpen(true)
  }, [])

  const closeLiveOrdersModal = useCallback(() => {
    setIsModalOpen(false)
  }, [])

  return (
    <>
      <LiveOrdersModal
        open={isModalOpen}
        onClose={closeLiveOrdersModal}
        strategyId={strategyId}
        title={`${strategyName} Live Orders`}
        dataUrl={liveOrdersUrl}
        postUrl={controlCloseOrderUrl}
      />

      <Tooltip title='View live orders'>
        <span>
          <IconButton size='small' disabled={isDisabled} onClick={openLiveOrdersModal}>
            <AutoModeIcon/>
          </IconButton>
        </span>
      </Tooltip>
    </>
  )
}

export default React.memo(LiveOrdersModalTrigger)
